import React, { useState } from 'react';
import './ResponseExample.css';

/**
 * ResponseExample Component
 * Displays formatted JSON response examples
 */
const ResponseExample = ({ 
  response = {}, 
  statusCode = 200,
  title = 'Response'
}) => {
  const [expanded, setExpanded] = useState(true);
  const [copied, setCopied] = useState(false);

  const jsonString = JSON.stringify(response, null, 2);

  const handleCopy = () => {
    navigator.clipboard.writeText(jsonString);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="response-example">
      <div className="response-example-header">
        <div className="response-example-title-group">
          <span className="response-example-title">{title}</span>
          <span className={`response-status response-status-${Math.floor(statusCode / 100)}xx`}>
            {statusCode}
          </span>
        </div>
        <div className="response-example-actions">
          <button 
            className="response-example-toggle"
            onClick={() => setExpanded(!expanded)}
            aria-label={expanded ? 'Collapse' : 'Expand'}
          >
            {expanded ? '−' : '+'}
          </button>
          <button 
            className="response-example-copy"
            onClick={handleCopy}
            aria-label="Copy JSON"
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      </div>
      {expanded && (
        <pre className="response-example-content">
          <code>{jsonString}</code>
        </pre>
      )}
    </div>
  );
};

export default ResponseExample;
